import { useController } from "react-hook-form"

import { ControlValueFn } from "@/types/ts-helpers"
import { InputField, InputFieldProps } from "./ui/input-field"

/* -------------------------------------------------------------------------------------------------
 * types
 * -----------------------------------------------------------------------------------------------*/

type ControlledInputProps = InputFieldProps & {
  controlValue?: ControlValueFn
}

/* -------------------------------------------------------------------------------------------------
 * component
 * -----------------------------------------------------------------------------------------------*/

const ControlledInput = ({
  controlValue = (controllerField) => controllerField,
  ...props
}: ControlledInputProps) => {
  const field = controlValue(useController({ name: props.name }).field)
  return <InputField {...field} {...props} />
}

export { ControlledInput }
export type { ControlledInputProps }
